import { render } from "./User_manage.vue?vue&type=template&id=770208f8"
import script from "./User_manage.vue?vue&type=script&lang=js"
export * from "./User_manage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__